'use strict';

function CardSortModel(ModelFactory, $rootScope, CardFilterModel) {
  var self = this;
  var sortModel = ModelFactory.create('CardSortModel', ['sortOrder', 'cards']);

  self.onSortOrderChanged = sortModel.onSortOrderChanged;
  self.onCardsChanged = sortModel.onCardsChanged;
  self.cards = sortModel.cards;

  sortModel.sortOrder({
    field: 'cardNumber',
    direction: 'asc'
  });

  self.sortField = function () {
    return _.get(sortModel.sortOrder(), 'field');
  };

  self.sortDirection = function () {
    return _.get(sortModel.sortOrder(), 'direction');
  };

  self.isSorted = function (fieldName) {
    return self.sortField() === fieldName;
  };

  self.isSortedAscending = function () {
    return self.sortDirection() === 'asc';
  };

  self.isSortedDescending = function () {
    return self.sortDirection() === 'desc';
  };

  self.setSortField = function (fieldName) {
    var newDirection;
    if (self.isSorted(fieldName)) {
      newDirection = oppositeDirection(self.sortDirection());
    } else {
      newDirection = 'asc';
    }

    sortModel.sortOrder({
      field: fieldName,
      direction: newDirection
    });
  };

  function sort(cards) {
    return _.orderBy(cards,
      [self.sortField()],
      [self.sortDirection()]
    );
  }

  function onCardsOrSortOrderChanged() {
    sortModel.cards(sort(CardFilterModel.cards()));
  }

  sortModel.onSortOrderChanged($rootScope, onCardsOrSortOrderChanged);
  CardFilterModel.onCardsChanged($rootScope, onCardsOrSortOrderChanged);

  function oppositeDirection(sortDirection) {
    if (sortDirection === 'desc') {
      return 'asc';
    } else {
      return 'desc';
    }
  }
}

angular.module('amexReconciliationApp')
  .service('CardSortModel', CardSortModel);



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/CardSortModel.js
// module id = 578
// module chunks = 0